module.exports = __webpack_public_path__ + "media/flags/pl-flag-9bf4f774.svg";